import React from 'react';
import {Modal, Segment, Icon} from 'semantic-ui-react';
import CoverageComparisonTable from "./coverageComparisonTable";

export default function CoverageComparisonModal({handleClose, show}) {
    return (
        <Modal size={'small'} onClose={() => handleClose(false)} open={show}>
            <Modal.Header style={{fontSize: '16px'}}>
                <div style={{display: 'inline-block'}}>Coverage comparison</div>
                <span style={{float: 'right'}}><Icon name={'close'} floated={'right'} onClick={() => handleClose(false)} link/></span>
            </Modal.Header>
            <Modal.Content>
                <Segment basic style={{padding:'0px'}}><CoverageComparisonTable showHeader showCurrent/></Segment>
            </Modal.Content>
        </Modal>
    )
}
